import { render, staticRenderFns } from "./LengthTable.vue?vue&type=template&id=504698fc&scoped=true"
import script from "./LengthTable.vue?vue&type=script&lang=js"
export * from "./LengthTable.vue?vue&type=script&lang=js"
import style0 from "./LengthTable.vue?vue&type=style&index=0&id=504698fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504698fc",
  null
  
)

export default component.exports